import { render, staticRenderFns } from "./OutboundSidebar.vue?vue&type=template&id=de942be8&"
import script from "./OutboundSidebar.vue?vue&type=script&lang=ts&"
export * from "./OutboundSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundSidebar.vue?vue&type=style&index=0&id=de942be8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports